import MySwitch from "./MySwitch";

export default MySwitch;
